import React from 'react';
import { FaFlag, FaEraser, FaArrowRight, FaPaperPlane } from 'react-icons/fa';

const ExamActions = ({ onMark, onClear, onNext, onSubmit }) => (
  <div className="exam-actions">
    <button type="button" className="exam-action exam-action--review" onClick={onMark}>
      <FaFlag />
      <span>Mark &amp; Next</span>
    </button>
    <button type="button" className="exam-action exam-action--clear" onClick={onClear}>
      <FaEraser />
      <span>Clear Response</span>
    </button>
    <button type="button" className="exam-action exam-action--next" onClick={onNext}>
      <span>Save &amp; Next</span>
      <FaArrowRight />
    </button>
    <button type="button" className="exam-action exam-action--submit" onClick={onSubmit}>
      <FaPaperPlane />
      <span>Submit Test</span>
    </button>
  </div>
);

export default ExamActions;
